const setAuth = (token) => {
    localStorage.setItem("linktree-token", token);
}
export {setAuth}

const removeAuth = () => {
    localStorage.removeItem("linktree-token");
}
export { removeAuth }


const getmyAuth = () => {
    const res = localStorage.getItem("linktree-token");
    
    if(res === null){
        return false;
    }else{
        return res;
    }
}
export { getmyAuth }
